import ScaledImage from '../ScaledImage'

import styles from './auth.module.scss'
import classNames from 'classnames'

const AuthWrapper = ({ children, image, imageText, stage, referImage, referLayout }) => {
  return (
    <div className={classNames(styles.authWrapper, { [styles.referLayout]: referLayout })}>
      <div className={classNames(styles.imageWrapper, { [styles.referImage]: referImage })}>
        <ScaledImage style={{ height: '100%', width: '100%' }} fluid={image} />
        {imageText && stage === 0 && (
          <div className={styles.imageTextWrapper}>
            <div className={styles.imageText}>{imageText}</div>
          </div>
        )}
        {imageText && stage === 1 && (
          <div className={styles.imageTextWrapper}>
            <div className={styles.imageText}>Share the Word</div>
          </div>
        )}
      </div>
      <div className={classNames(styles.formContainer, { [styles.referLayout]: referLayout })}>
        <div className={styles.formWrapper}>{children}</div>
      </div>
    </div>
  )
}

export default AuthWrapper
